import React, { useEffect } from 'react';
import { usePortfolioContext } from '../contexts/PortfolioContext';
import { useNotificationSettings } from '../hooks/useNotificationSettings';
import NotificationSettingsForm from './NotificationSettingsForm';

const NotificationSettingsModal = ({ isOpen, onClose }) => {
  const { currentPortfolioId } = usePortfolioContext();

  const {
    formData,
    validation,
    loading,
    updating,
    handleInputChange,
    handleSubmit,
  } = useNotificationSettings({
    portfolioId: currentPortfolioId,
    skip: !isOpen,
    onSuccess: onClose,
  });

  useEffect(() => {
    if (!isOpen) return;
    const handleEscKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleEscKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { 
      document.removeEventListener('keydown', handleEscKey); 
      document.body.style.overflow = prev || 'unset'; 
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center overflow-y-auto py-8">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-11/12 max-w-2xl my-auto">
        <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200 dark:border-gray-700">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Notification Settings</h3>
          <button 
            onClick={onClose} 
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {loading ? (
          <div className="p-8 text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
          </div>
        ) : (
          <div className="px-4 py-4">
            <NotificationSettingsForm
              formData={formData}
              validation={validation}
              updating={updating}
              handleInputChange={handleInputChange}
              handleSubmit={handleSubmit}
              showMoverAlerts={true}
              compact={true}
              onCancel={onClose}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationSettingsModal;
